// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__20Eqt","icon":"style_icon__2iSKq","title":"style_title__1nHXO"};